module.exports = __webpack_public_path__ + "img/1536465038.ef040eb5.jpg";